/* eslint-disable import/no-cycle */
import styled, { css } from 'styled-components'

import HybridLink from 'components/hybrid-link'
import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Container = styled(HybridLink).attrs(({ item, index }) => ({
  className: e2eClasses('thumbnail.box'),
  'data-damero-destino': item?.destination,
  'data-damero-origen': item?.origin,
  'data-damero-precio': item?.fare,
  'data-damero-moneda': item?.currency,
  'data-damero-cabina': item?.cabin,
  'data-damero-descripcion': item?.description,
  'data-descripcion': item?.dataDescription,
  'data-seccion': item?.dataSection,
  'data-posicion': index
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  display: grid;
  grid-template-rows: repeat(${({ highlighted }) => (highlighted ? '2' : '3')}, 1fr);
  text-decoration: none;

  ${({ highlighted }) =>
    highlighted &&
    css`
      justify-items: flex-end;
      grid-column-start: span 2;
    `};

  overflow: hidden;
  position: relative;
  height: 100%;
  width: ${({ width }) => width || '100%'};
  border-radius: 8px;
  box-shadow: 0 1px 5px 0 ${({ theme }) => theme.shadow.black06};
  background-color: white;

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`
export const Header = styled.div.attrs(() => ({
  className: e2eClasses('thumbnail.header')
}))`
  ${({ highlighted }) =>
    highlighted &&
    css`
      grid-row-start: 1;
      grid-row-end: 3;
    `};

  display: flex;
  z-index: 2;
  height: 100%;
  width: ${({ highlighted }) => (highlighted ? '40%' : '100%')};
  padding: 16px;
  transition: background-color 0.5s ease;
  background-color: ${({ color }) => color};

  ${mediaQueries.mobile`
    grid-row: 2;
    align-items: flex-end;
  `};
`
export const Footer = styled.div.attrs(() => ({
  className: e2eClasses('thumbnail.footer')
}))`
  grid-row: 3;
  z-index: 2;
  padding: 16px;
  display: flex;
  height: 100%;
  width: ${({ highlighted }) => (highlighted ? '40%' : '100%')};
  transition: background-color 0.5s ease;
  background-color: ${({ color }) => color};
  flex-direction: column;
  align-self: flex-end;
`
export const Badge = styled.label.attrs(() => ({
  className: e2eClasses('thumbnail.badge')
}))`
  padding: 4px 12px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.blueLighter};
  color: ${({ theme }) => theme.colors.blue};
  font-size: 12px;
  width: max-content;
`
export const PrimaryLabel = styled.label.attrs(() => ({
  className: e2eClasses('thumbnail.primaryLabel')
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 18px;
  grid-column: 1;
`
export const SecondaryLabel = styled.div.attrs(() => ({
  className: e2eClasses('thumbnail.secondaryLabel')
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 14px;
  grid-column: 1;
`
export const Description = styled.div.attrs(() => ({
  className: e2eClasses('thumbnail.description')
}))`
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  & p {
    color: ${({ theme, color }) =>
      color == 'transparent' ? 'white !important' : theme.colors.blue};
  }

  ${({ color }) =>
    color === 'transparent' &&
    css`
      & label {
        color: ${({ theme }) => theme.colors.white};
      }
      & img {
        filter: brightness(09) saturate(9.9);
      }
    `};
`
export const Fare = styled.label.attrs(() => ({
  className: e2eClasses('thumbnail.fare')
}))`
  grid-column: ${({ highlighted }) => (highlighted ? '1' : '2')};
  text-align: ${({ highlighted }) => (highlighted ? 'left' : 'right')};
  color: ${({ theme }) => theme.colors.blue};
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
`
export const Icon = styled.img`
  justify-self: flex-end;
  display: flex;
`

export const Image = styled.img.attrs(() => ({
  className: e2eClasses('thumbnail.image')
}))`
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  transition: transform 0.5s ease;
  object-fit: cover;
  object-position: center center;

  ${({ hovered }) =>
    hovered &&
    css`
      transform: scale(1.2);
    `};
`
